import { apiRequest } from "./api";

function getTodayDateString(timezone = "Asia/Kolkata") {
  try {
    const formatter = new Intl.DateTimeFormat("en-CA", {
      timeZone: timezone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    return formatter.format(new Date()); // Returns YYYY-MM-DD
  } catch (e) {
    return new Date().toISOString().split("T")[0];
  }
}

/**
 * Fetch Admin Dashboard data, including metrics and charts.
 * Endpoint: GET /admin/dashboard
 *
 * @param {Object} [params]
 * @param {string} [params.range="monthly"]      - "weekly" | "monthly" | "quarterly" | "yearly"
 * @param {string} [params.date="today"]         - YYYY-MM-DD anchor date
 * @param {string} [params.sections="metrics,analytics"] - Comma-separated blocks
 * @param {string} [params.trendBasis="same_period"] - "same_period" | "full_month" | "projected"
 * @param {string} [params.tz="Asia/Kolkata"]    - Timezone
 */
export async function fetchDashboardData({
  range = "monthly",
  date = "today",
  sections = "metrics,analytics",
  trendBasis = "same_period",
  tz = "Asia/Kolkata",
} = {}) {
  const targetDate = (date === "today" || !date) ? getTodayDateString(tz) : date;

  const qs = new URLSearchParams();
  qs.set("range", range);
  qs.set("date", targetDate);
  qs.set("sections", sections);
  qs.set("trend_basis", trendBasis);
  qs.set("tz", tz);

  return await apiRequest(`/admin/dashboard?${qs.toString()}`);
}
